import Dimens from '../../../../theme/dimens';
import { useTheme } from '@mui/material';

/**
 * useStyles custom hook generates MUI theme dependent styles for the AdminsTab component.
 * 
 * @returns An object containing the styled classes.
 */
const useStyles = () => {

	const { xs, lg, xl, section } = Dimens.spacing;
	const theme = useTheme();

	const styles = {
		wrapper: {
			display: 'flex',
			flex: 1,
			height: 'inherit',
			overflow: 'hidden'
		},
		innerWrapper: {
			flexDirection: 'column',
			display: 'flex',
			flex: 1,
			p: section,
			overflow: 'auto',
			[theme.breakpoints.down('sm')]: {
				p: lg
			}
		},
		searchHeader: {
			display: 'flex',
			flexDirection: 'row',
			pb: section,
			[theme.breakpoints.down('sm')]: {
				pb: lg
			}
		},
		searchBarWrapper: {
			flex: 1,
			mr: xs
		},
		tableContainer: (hasNoResults: boolean) => ({
			flex: 1,
			backgroundImage: 'none',
			border: `${Dimens.menuBorderWidth} solid ${theme.palette.background.default}`,
			borderRadius: Dimens.radius.md,
			boxShadow: 'none',
      '& table': {
        height: hasNoResults ? '100%' : 'auto'
      },
			'& th': {
				bgcolor: theme.palette.background.paper,
				borderBottom: `${Dimens.menuBorderWidth} solid ${theme.palette.background.default}`,
			},
			'& td': {
				borderBottom: `${Dimens.menuBorderWidth} solid ${theme.palette.background.default}`,
				whiteSpace: 'nowrap'
			}
		}),
		footer: {
			my: xl,
			// borderTop: `${Dimens.menuBorderWidth} solid ${theme.palette.background.default}`,
			bottom: 0,
			px: 0,
			pt: xl,
			bgcolor: theme.palette.background.paper,
			position: 'sticky',
			textAlign: 'end',
			[theme.breakpoints.down('sm')]: {
				textAlign: 'center',
				display: 'flex',
				'& button': {
					flex: 1
				}
			}
		},
		noResultCell: {
			verticalAlign: 'middle !important',
			borderBottom: `0 !important`
		},
		noDataRow: {
			display: 'flex',
			flex: 1,
			justifyContent: 'center'
		}
	};

	return styles;
};

export default useStyles;